export default __webpack_public_path__ + "static/media/coin_blue.8ca4e74a.svg";